import { ExperimentName } from 'shared/experiments/consts/types'
import { Experiment } from 'types/shopConfig'
import { DEFAULT_VARIANT_NAME } from 'shared/experiments/consts'

import { getExperimentsToActivate } from 'views/assets/scripts/optimizely'
import buildClientAPI from 'views/providers/clientAPI'
import { getPageProperties } from 'views/utils/shopAndRuntimeConfigUtils'
import { DEFAULT_EXPERIMENT } from 'shared/experiments/consts/experiments'

export const activateExperiment = (name: ExperimentName) => {
  const { clientFockService } = buildClientAPI()
  clientFockService.activateExperiments([name])
}

export const isExperimentEnabled = (nameToFind: ExperimentName): boolean => {
  const experimentsToActivate = getExperimentsToActivate({
    includeExperimentsWithPreventActivation: true
  })

  return experimentsToActivate.some(name => name === nameToFind)
}

export const isExperimentActive = (
  name: ExperimentName,
  experiments: Experiment[]
): boolean => {
  return experiments.some(
    experiment =>
      experiment.name === name && experiment.variant !== DEFAULT_VARIANT_NAME
  )
}

export const isAnyExperimentActive = (
  names: ExperimentName[],
  experiments: Experiment[]
): boolean =>
  experiments.some(
    ({ name, variant }) =>
      variant !== DEFAULT_VARIANT_NAME && names.includes(name)
  )

export const getExperiments = (
  names: ExperimentName[],
  experiments: Experiment[]
): Experiment[] => experiments.filter(({ name }) => names.includes(name))

export const getExperiment = (experimentName: ExperimentName): Experiment => {
  const { experiments: experimentsList = [] } = getPageProperties()

  const experiment =
    experimentsList.find(({ name }) => name === experimentName) ||
    DEFAULT_EXPERIMENT

  return { ...experiment, name: experimentName } as Experiment
}
